import { createApp } from 'vue';
import { mount } from '../dom-lifecycle';
import Quiz from '../quiz/Quiz.vue';

mount('[data-quiz]', function (quiz) {
    const { question, stageTotal, answerUrl, token, status, name, introVideo, videoBase, videoVersions, logoutUrl, campaignEnded } = quiz.dataset;
    createApp(Quiz, {
        question: JSON.parse(question),
        stageTotal: Number(stageTotal),
        answerUrl,
        token,
        status,
        name,
        introVideo,
        videoBase,
        videoVersions: JSON.parse(videoVersions),
        logoutUrl,
        campaignEnded: Boolean(campaignEnded),
    }).mount(quiz);
});
